import * as React from 'react';

import Form from './form'
import PostSubmit from './postSubmit'

interface IContainerProps {}

interface IContainerState {
    submitting: boolean
}

export class Container extends React.Component<IContainerProps, IContainerState> {
    constructor(props: IContainerProps) {
        super(props);

        this.state = {
            submitting: false,
        };
    }

    async sendRequest(data: any) {
        this.setState({
            submitting: true
        });

        let jsonData = JSON.stringify(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let request = new Request("/api/form_submit", {
            headers: headers,
            method: 'POST',
            body: jsonData
        });
        await fetch(request);
    }

    handleSubmit(data: any) {
        let sortedData = {
            wants: {
                size: Number(data["want_size"]),
                rent: Number(data["want_rent"]),
                landlord: data["want_landlord"],
                postcode: data["want_postal_code"],
                floor: Number(data["own_floor"]),
                toilet: data["want_toilet"] === true,
                bathroom: data["want_bathroom"] === true,
                livingRoom: data["want_living_room"] === true,
                personalSpaces: Number(data["want_personal_spaces"]),
            },
            room: {
                size: Number(data["own_size"]),
                rent: Number(data["own_rent"]),
                hospice: data["own_hospice"]  === true,
                landlord: data["own_landlord"],
                postcode: data["own_postal_code"],
                floor: Number(data["own_floor"]),
                toilet: data["own_toilet"] === true,
                bathroom: data["own_bathroom"] === true,
                livingRoom: data["own_living_room"] === true,
                personalSpaces: Number(data["own_personal_spaces"]),
            },
            user: {
                email: data["email"],
                firstName: data["firstName"],
                lastName: data["lastName"],
            }
        }

        this.sendRequest(sortedData)
    }

    render() {
        if (this.state.submitting) {
            return <PostSubmit />
        }
        return (
            <Form onSubmit={(data: any) => this.handleSubmit(data)}/>
        )
    }
}

export default Container
